import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import * as moment from 'moment';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {AuthenticationService} from '../../../../shared/services/authentication/authentication.service';
import {Location} from '../../../../shared/types/location.type';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {ProjectService} from '../../../../shared/services/project/project.service';

@Component({
  selector: 'app-event-dyn-header-filters',
  templateUrl: './event-dyn-header-filters.component.html',
  styleUrls: ['./event-dyn-header-filters.component.scss']
})
export class EventDynHeaderFiltersComponent implements OnInit {

  @Output() filtersChange: EventEmitter<any> = new EventEmitter();
  initialTime = {hour: 0, minute: 0};
  initialStartDate = moment(new Date()).subtract('7', 'days').toDate();
  startTime: any = Object.assign({}, this.initialTime);
  endTime: any = Object.assign({}, this.initialTime);

  selectedLocation: number;

  public locations: Location.clientSide[] = [];
  public chartCategories: string[] = [];

  public startDateControl: FormControl = new FormControl(Object.assign({}, this.initialStartDate));
  public startTimeControl: FormControl = new FormControl(Object.assign({}, this.initialTime));
  public endDateControl: FormControl = new FormControl(new Date());
  public endTimeControl: FormControl = new FormControl(Object.assign({}, this.initialTime));
  public selectedLocationControl: FormControl = new FormControl();
  public chartCategoryControl: FormControl = new FormControl('Range');
  public minCategoryLimitControl: FormControl = new FormControl();
  public mediumCategoryLimitControl: FormControl = new FormControl();
  public maxCategoryLimitControl: FormControl = new FormControl();

  public projectId: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private projectsListService: ProjectService,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private toastrService: ToastrService) {
  }

  ngOnInit() {
    this.startDateControl.setValue(this.initialStartDate);
    this.startTimeControl.setValue(this.initialTime);
    this.endTimeControl.setValue(this.initialTime);
    this.chartCategoryControl.setValue('Range');
    this.chartCategories = this.getChartCategories();
    this.projectId = this.activatedRoute.snapshot.paramMap.get('idProject');
    this.projectsListService.getProjectLocations(this.projectId)
      .subscribe((project: any) => {
        if (project) {
          this.locations = project.project_device_locations.filter((location) => location.active);
        }
      });
  }

  getChartCategories() {
    return ['Duration', 'ValStart', 'ValEnd', 'Gap', 'ValMin', 'ValMax', 'Range', 'Mean', 'Median'];
  }

  applyDate() {
    const filters = this.getFormattedFiltersValue();
    if (!filters.selectedLocation) {
      this.toastrService.error(this.translateService.instant('PLEASE_LOCATION'), this.translateService.instant('ERROR'));
      return;
    }
    this.filtersChange.emit(filters);
  }

  reset() {
    this.selectedLocationControl.reset();
    this.minCategoryLimitControl.reset();
    this.mediumCategoryLimitControl.reset();
    this.maxCategoryLimitControl.reset();
    this.startDateControl.setValue(this.initialStartDate);
    this.startTimeControl.setValue(this.initialTime);
    this.endTimeControl.setValue(this.initialTime);
    this.endDateControl.setValue(new Date());
    this.chartCategoryControl.setValue('Range');
  }

  getCSV() {
    const baseUrl = environment.apiUrl + environment.guardedRoute;
    const token = this.authenticationService.getToken();
    const filters = this.getFormattedFiltersValue();
    if (!filters.selectedLocation) {
      this.toastrService.error(this.translateService.instant('PLEASE_LOCATION'), this.translateService.instant('ERROR'));
      return;
    }
    window.open(baseUrl + 'auth/export/event-dyn/csv?dateStart=' + filters.startDate + '&dateEnd=' + filters.endDate + '&location=' + filters.selectedLocation + '&token=' + token);
  }


  private getFormattedFiltersValue() {

    const checkDoubleDigits = (value: number) => value < 10 ? '0' + value.toString() : value;

    const startDate = moment(this.startDateControl.value).format('YYYY-MM-DD');
    const startTime = checkDoubleDigits(this.startTimeControl.value.hour) + ':' + checkDoubleDigits(this.startTimeControl.value.minute);

    const endDate = moment(this.endDateControl.value).format('YYYY-MM-DD');
    const endTime = checkDoubleDigits(this.endTimeControl.value.hour) + ':' + checkDoubleDigits(this.endTimeControl.value.minute);

    return {
      startDate: `${startDate}T${startTime}:00.000Z`,
      endDate: `${endDate}T${endTime}:00.000Z`,
      selectedLocation: this.selectedLocationControl.value,
      minCategoryLimit: parseFloat(this.minCategoryLimitControl.value),
      mediumCategoryLimit: parseFloat(this.mediumCategoryLimitControl.value),
      maxCategoryLimit: parseFloat(this.maxCategoryLimitControl.value),
      chartCategory: this.chartCategoryControl.value
    };
  }
}
